import PropTypes from 'prop-types';
import { useEffect } from 'react';

import Topics from './Topics';
import { GRID } from '../constants/displayAs';
import { SUPER_CATEGORY } from '../constants/types';
import { useTopicsIndexContext } from '../contexts/TopicsIndexContext';
import useTopicsCategories from '../hooks/useTopicsCategories';
import useTopicsOtherTopics from '../hooks/useTopicsOtherTopics';

const TopicsOtherTopics = ({ displayAs = GRID, rowsToDisplay }) => {
  const {
    name,
    topics,
    totalTopics,
    isFetchingTopics,
    params,
    loadNextPage,
    handleFetchTopics,
    updateTopicApproval,
  } = useTopicsOtherTopics({ rowsToDisplay });
  const { setHandleFetchOtherTopics, currentView } = useTopicsIndexContext();
  const { totalCategories } = useTopicsCategories();

  useEffect(() => {
    if (handleFetchTopics && setHandleFetchOtherTopics) {
      setHandleFetchOtherTopics(() => handleFetchTopics);
    }
  }, [handleFetchTopics, setHandleFetchOtherTopics]);

  return (
    <Topics
      dataTestId="topics-other-topics"
      name={name}
      topics={topics}
      totalTopics={totalTopics}
      isFetchingTopics={isFetchingTopics}
      displayAs={displayAs}
      loadNextPage={loadNextPage}
      updateTopicApproval={updateTopicApproval}
      params={params}
      displayBreadcrumb={
        currentView === SUPER_CATEGORY ? totalCategories > 0 : true
      }
    />
  );
};

TopicsOtherTopics.protoTypes = {
  displayAs: PropTypes.string,
  rowsToDisplay: PropTypes.number,
};

export default TopicsOtherTopics;
